import { preprocessContent } from '@circuit/markdown/utils';
import { type FC } from 'preact/compat';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

import '@circuit/markdown/styles';

interface ChatMarkdownProps {
  children?: string;
  isStreaming: boolean;
}

function isSafeHref(url: string | undefined): boolean {
  if (!url) return false;
  return !/^(?:javascript|vbscript|data)\s*:/iu.test(url.trim());
}

export function proactivelyCloseMarkdown(text: string): string {
  const codeBlockRegex = /```/g;
  const matches = [...text.matchAll(codeBlockRegex)];

  if (matches.length % 2 !== 0) {
    return text + '\n```';
  }

  return text;
}

export const ChatMarkdown: FC<ChatMarkdownProps> = ({
  children = '',
  isStreaming,
}) => {
  const raw = isStreaming ? proactivelyCloseMarkdown(children) : children;
  const content = preprocessContent(raw);

  return (
    <div className='markdownContent'>
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        components={{
          // Cast needed: react-markdown types expect React.ReactNode but Preact returns VNode
          a: (({ href, children: linkChildren }: any) => (
            <a
              href={isSafeHref(href) ? href : undefined}
              target='_blank'
              rel='noopener noreferrer'
            >
              {linkChildren}
            </a>
          )) as any,
          table: (({ children, node: _node, ...props }: any) => (
            <div className='markdownTableScroll'>
              <table {...props}>{children}</table>
            </div>
          )) as any,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};
